/**
 * Minimal utility for handling initial page load scrolling when URL contains a hash
 * This complements the CSS scroll-padding-top for ToC link clicks
 */

/**
 * Handles initial page load scrolling when URL contains a hash
 * Should be called after the page has loaded and elements are rendered
 */
export const handleInitialHashScroll = (): void => {
  const hash = window.location.hash;
  if (hash && hash.length > 1) {
    const elementId = hash.substring(1); // Remove the # symbol
    const element = document.getElementById(elementId);

    if (element) {
      // Use a small delay to ensure the page is fully rendered
      setTimeout(() => {
        // Let the browser handle the scrolling with CSS scroll-padding-top
        element.scrollIntoView({ behavior: 'smooth' });
      }, 500);
    }
  }
};
